module.exports = __webpack_public_path__ + "img/充电站点.bee05cd2.png";